import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { Form, Hyperlink } from '@openedx/paragon';
import PropTypes from 'prop-types';

import { useT } from '../../../context/LanguageContext';

const TermsOfService = (props) => {
  const { t } = useT();
  const {
    errorMessage, onChangeHandler, value } = props;

  return (
    <div id="terms-of-service" className="micro text-muted">
      <Form.Checkbox
        className="form-field--checkbox mt-1"
        id="tos"
        checked={value}
        name="terms_of_service"
        value={value}
        onChange={onChangeHandler}
      >
        {t('register.page.terms.of.service', {
            platformName: getConfig().SITE_NAME,
            termsOfService: (
              <Hyperlink variant="muted" destination={getConfig().TOS_LINK || '#'} target="_blank">
                {t('terms.of.service')}
              </Hyperlink>
            ),
          })}
      </Form.Checkbox>
      {errorMessage && (
        <Form.Control.Feedback type="invalid" className="form-text-size" hasIcon={false}>
          {errorMessage}
        </Form.Control.Feedback>
      )}
    </div>
  );
};

TermsOfService.defaultProps = {
  errorMessage: '',
  value: false };

TermsOfService.propTypes = {
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  value: PropTypes.bool };

export default TermsOfService;
